import { render, staticRenderFns } from "./ModulePanomaxWebcamForm.vue?vue&type=template&id=e21dbb72&scoped=true"
import script from "./ModulePanomaxWebcamForm.vue?vue&type=script&lang=js"
export * from "./ModulePanomaxWebcamForm.vue?vue&type=script&lang=js"
import style0 from "./ModulePanomaxWebcamForm.vue?vue&type=style&index=0&id=e21dbb72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21dbb72",
  null
  
)

export default component.exports